export default "__VITE_ASSET__dWIKm1Ct__"